const ConversationTypes = {
    REQUEST: 1,
    SOCIAL: 2,
}
export default ConversationTypes